module.exports = __webpack_public_path__ + "img/6.519be96.png";